import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import {
  recordsPublicDetails,
  recordReset,
  recordsDetails,
} from "@ovrture/react-redux";
import { useSelector, useDispatch } from "react-redux";
const UnderConstruction = () => {
  const dispatchAction = useDispatch();
  useEffect(() => {
    //dispatchAction(recordsPublicDetails());
  }, []);

  const { publicDetails } = useSelector((state) => {
    return {
      publicDetails: state?.records?.publicDetails?.data,
    };
  });
  return (
    <div className="under-construction-page">
      <div className="under-construction-nav bg-dark">
        <div className="float-end">
          <div className="mailWrapper">
            <a
              className="mailLink"
              href="mailto:neha.deshmukh+pbtest@techment.com"
            >
              {publicDetails?.adminEmail}
            </a>
          </div>
        </div>
      </div>
      <div className="outer-wrapper">
        <div className="under-construction mt-5 mb-5">
          <Container>
            <div className="text-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="90"
                height="92"
                viewBox="0 0 90 92"
              >
                <g>
                  <g>
                    <path
                      fill="#a5a9b2"
                      d="M8.182 69.545h24.545a4.08 4.08 0 0 1 4.091 4.091 4.083 4.083 0 0 1-4.09 4.091H4.09A4.092 4.092 0 0 1 0 73.637V24.544a4.09 4.09 0 0 1 4.09-4.09h16.365V4.09A4.09 4.09 0 0 1 24.545 0h49.091a4.09 4.09 0 0 1 4.091 4.09v28.637a4.083 4.083 0 0 1-4.09 4.091 4.083 4.083 0 0 1-4.092-4.09V8.181H28.636v12.273h24.546a4.09 4.09 0 0 1 4.09 4.09v28.637a4.092 4.092 0 0 1-4.09 4.09H24.545a4.092 4.092 0 0 1-4.09-4.09V28.636H8.182zm20.454-20.454h20.455V28.636H28.636zM90 58.9c0 7.327-6 13.283-13.287 13.283-2.05 0-3.989-.466-5.713-1.297L52 89.902c-1.751 1.726-4.554 1.726-6.284 0a4.454 4.454 0 0 1 0-6.263l19.01-19.01A13.07 13.07 0 0 1 63.43 58.9c0-7.327 5.96-13.287 13.283-13.287v8.856a4.433 4.433 0 0 0-4.427 4.43 4.433 4.433 0 0 0 4.427 4.431 4.434 4.434 0 0 0 4.43-4.43z"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
            <div className="element-wrapper">
              <h5 className="text-center elementHeading">
                Editing in Progress
              </h5>
              <p className="elementText">
                This page is currently being edited and will<br></br>
                be available soon. Please contact your<br></br>
                relationship manager if you have any questions.
              </p>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
